/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Bank_Diff_LinkInputs */

const vi_cashflow_bank_diff_link = /** @type {(inputs: Cashflow_Bank_Diff_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở màn đối soát CK →`)
};

/**

* @param {Cashflow_Bank_Diff_LinkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_bank_diff_link = /** @type {((inputs?: Cashflow_Bank_Diff_LinkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Bank_Diff_LinkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_bank_diff_link(inputs)
});